import HistoryIcon from '@material-ui/icons/History';
import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { IMenu } from '@hooks/useMenu';
import { IModalWindow } from '@hooks/useModalWindow';
import EditIcon from '@material-ui/icons/Edit';
import ILinha from '@model/Linha';
import React from 'react';
import { Divider } from '@material-ui/core';

export type LinhaMenuProps = {
    menu: IMenu
    linha: ILinha
    editarModal: IModalWindow
    atividadeModal: IModalWindow
}

export function LinhaMenu ({ linha, menu, editarModal, atividadeModal }: LinhaMenuProps) {
    return (
        <RowMenu menu={menu}>
            <RowMenuItem 
                key={1}
                icon={<EditIcon />}
                text="Editar Linha"
                onClick={menu.handleItemClick(editarModal.open)} 
            />

            <Divider />

            <RowMenuItem 
                key={2} 
                onClick={menu.handleItemClick(atividadeModal.open)}
                text="Atividades"
                icon={<HistoryIcon />}
            />

        </RowMenu>
    )
}